export const convertImageToWeb = (file: File): Promise<File> => {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = URL.createObjectURL(file);

    img.onload = () => {
      URL.revokeObjectURL(img.src); // Libera memória

      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");

      if (!ctx) {
        resolve(file);
        return;
      }

      ctx.drawImage(img, 0, 0);

      canvas.toBlob((blob) => {
        if (blob) {
          const webpFile = new File(
            [blob],
            file.name.replace(/\.[^/.]+$/, "") + ".webp",
            { type: "image/webp" }
          );
          resolve(webpFile);
        } else {
          resolve(file);
        }
      }, "image/webp");
    };

    img.onerror = () => {
      URL.revokeObjectURL(img.src); // Libera memória mesmo em erro
      resolve(file);
    };
  });
};

export default convertImageToWeb;